module.exports = __webpack_public_path__ + "img/gauge-3.109a1a7e.svg";